import { ModelType, eventType } from "../../../../../../API";

import { CHART_CONTAINER_HEIGHT } from "../../../system-health/common/values";
import CircularLoading from "../../../../../../common/components/progress/CircularLoading";
import { FeedbackInsightsChartProps } from "../../models";
import SimplePaperWrapper from "../../../../../../common/components/item/SimplePaperWrapper";
import StatisticsNoDataView from "../../../system-performance/components/StatisticsNoDataView";
import StyledChart from "../../../../../../common/components/apexchart/StyledChart";
import Typography from "@mui/material/Typography";
import { useFalsePositiveEventsChart } from "../../hooks/useFalsePositiveEventsChart";

const ConfirmedLeakDetectionsContainer = ({
  selectedLocations,
  activeTimePeriod,
}: FeedbackInsightsChartProps) => {
  const { series, options, loading, refetching, showNoData } =
    useFalsePositiveEventsChart(
      eventType.confirmedLeakDetections,
      [ModelType.gasleak, ModelType.liquidleak],
      selectedLocations,
      activeTimePeriod
    );

  return (
    <SimplePaperWrapper
      sx={{
        padding: "1.5em",
        height: CHART_CONTAINER_HEIGHT,
        borderRadius: "8px",
      }}
    >
      <Typography mb="1em" variant="h5">
        Confirmed Detections
      </Typography>
      {(loading || refetching) && <CircularLoading />}
      {!loading && !showNoData && (
        <StyledChart
          options={options}
          series={series}
          height={300}
          type="bar"
        />
      )}
      {showNoData && <StatisticsNoDataView />}
    </SimplePaperWrapper>
  );
};

export default ConfirmedLeakDetectionsContainer;
